import InstalatorConfig from './instalator.config';
import InstalatorRegistrationUsersController from './instalator-registration.users.controller';
import InstalatorRegistrationConfirmUsersController from './instalator-registration-confirm.users.controller';
import InstalatorLoginUsersController from './instalator-login.users.controller';
import InstalatorConfirmedUsersController from './instalator-confirmed.users.controller';
import InstalatorActivationUsersController from './instalator-activation.users.controller';
import InstalatorSharedResourceUsersController from './instalator-shared-resources.users.controller';

let instalatorModule = angular.module('ff.users.instalator', []);

instalatorModule.config(InstalatorConfig);

instalatorModule.controller('InstalatorRegistrationUsersController', InstalatorRegistrationUsersController);
instalatorModule.controller('InstalatorRegistrationConfirmUsersController', InstalatorRegistrationConfirmUsersController);
instalatorModule.controller('InstalatorLoginUsersController', InstalatorLoginUsersController);
instalatorModule.controller('InstalatorConfirmedUsersController', InstalatorConfirmedUsersController);
instalatorModule.controller('InstalatorSharedResourceUsersController', InstalatorSharedResourceUsersController);
instalatorModule.controller('InstalatorActivationUsersController', InstalatorActivationUsersController);

export default instalatorModule = instalatorModule.name;



// WEBPACK FOOTER //
// ./src/users/instalator/instalator.module.js